module.exports = __webpack_public_path__ + "img/background-shape-rectangle.79bea617.svg";